import React from 'react'
import { format as formatDate } from 'date-fns'

import Assigned from './Assigned'
import Verified from './Verified'

const TimelineSession = ({ senderFull, meta, type, date }) => {
  const formattedDate = React.useMemo(
    () => formatDate(date, 'MMM d, h:mm aaa'),
    [date]
  )

  if (type === 'assigned') {
    return <Assigned user={senderFull} meta={meta} date={formattedDate} />
  }

  if (type === 'verified') {
    return <Verified user={senderFull} meta={meta} date={formattedDate} />
  }

  return null
}

export default TimelineSession
